import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';

const ToolTip = props => {
    const [show, setShow] = useState(false);

    useEffect(() => {
        document.body.addEventListener('click', e => {
            if (!e.target.matches('.re-tooltip-contents *') && !e.target.matches('.re-popup-component *')) {
                setShow(false);
            }
        });
    }, []);

    const showContent = () => {
        setShow(!show);
    };

    return (
        <React.Fragment>
            <div
                onClick={showContent}
                className="re-tooltip-child-container"
                data-testid="tooltip"
                data-mixpanel-name="Intent"
                data-mixpanel-type={props.mixpanelType}
            >
                {props.children}
            </div>

            {show ? (
                <div
                    className={`${props.withArrow ? 're-tooltip-contents-with-arrow' : ''} re-tooltip-contents`}
                    data-testid="content"
                >
                    {props.withArrow ? <div className="re-tooltip-arrow" /> : null}
                    {props.overlay}
                </div>
            ) : null}
        </React.Fragment>
    );
};

ToolTip.propTypes = {
    overlay: PropTypes.object,
    children: PropTypes.node,
    mixpanelType: PropTypes.string,
    withArrow: PropTypes.bool
};
export default ToolTip;
